import { useQuery } from '@tanstack/react-query';
import { ErrorResponse, ParamsResponse } from 'interfaces/global.types';
import { toast } from 'react-toastify';
import homeService from 'services/home';

export const useHomeQuery: any = (params?: ParamsResponse) => {
  const queryKeys = params
    ? ['home_getAll', params.page, params.limit, params.search, params.control_date]
    : ['home_getAll'];
  return useQuery({
    queryKey: queryKeys,
    queryFn: () => homeService.getAll(params),
    onError: (error: ErrorResponse) => toast.error(error?.data?.detail),
  });
};
